import { sendTrialRequestNotificationRpc, sendSkuUpgradeNotificationRpc } from '../../__generated__/chirp/com/hubspot/personalization/rpc/RequestsRpc';
import { createSeatRequestRpc } from '../../__generated__/chirp/com/hubspot/personalization/rpc/SeatRequestRpc';
import { rpcClient } from '../client';
export const sendRequestTrialNotification = ({
  apiName
}) => rpcClient.call(sendTrialRequestNotificationRpc, {
  request: {
    apiName
  }
});
export const sendRequestSKUNotification = ({
  apiName
}) => rpcClient.call(sendSkuUpgradeNotificationRpc, {
  request: {
    apiName
  }
});
export const sendRequestSeatNotification = ({
  apiName,
  requestReason,
  requestedSeatType
}) => {
  return rpcClient.call(createSeatRequestRpc, {
    request: {
      apiName: apiName || undefined,
      requestReason: requestReason || undefined,
      requestedSeatType: requestedSeatType || undefined,
      sendAdminNotification: true
    }
  });
};